<template>
  <v-container fluid>
    <v-layout column align-center>
      Muslimträff
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'App',
  beforeRouteEnter() {
    window.location.replace("https://muslimtraff.se")
  }
}
</script>